import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { State } from "./types";

function handleRequest(
  state: State,
  { namespace }: Boundaries["retrieveResourceGroups"]["request"],
): State {
  const hasSearchedGroups = state.find(
    (result) => result.namespace === namespace,
  );

  return hasSearchedGroups
    ? state.map((result) =>
        result.namespace === namespace
          ? { ...result, request: setRequestStateToPending() }
          : result,
      )
    : [
        ...state,
        {
          namespace,
          groups: [],
          request: setRequestStateToPending(),
        },
      ];
}

export { handleRequest };
